import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import s from './FooterCopyright.scss';
var FooterCopyright = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement("div", null, t('siteFooter.copyright', {
            year: new Date().getFullYear(),
        })),
        React.createElement("div", { className: s['separator'] }),
        React.createElement("div", null, t('siteFooter.allRightsReserved'))));
};
FooterCopyright.displayName = 'FooterCopyright';
export default React.memo(FooterCopyright);
//# sourceMappingURL=FooterCopyright.js.map